import MicroModal from 'micromodal'

const $ = window.jQuery

export const init = () => {
  MicroModal.init()

  $('.js-trigger-modal').on('click', function (e) {
    e.preventDefault()
    const modalPrefix = this.dataset.id

    if ($(`#${modalPrefix}-modal`).length) {
      $(`#${modalPrefix}-modal`).remove()
    }

    $('body').append(createModal(`#${modalPrefix}-modal`, this.dataset.modalTitle))

    if (this.dataset.modalContent) {
      $(`#${modalPrefix}-modal-content`).html(this.dataset.modalContent)
    } else if (this.dataset.modalContentSelector) {
      const contentElement = document.querySelector(this.dataset.modalContentSelector)
      if (contentElement.length) {
        $(`#${modalPrefix}-modal-content`).html(contentElement.html())
      }
    } else if (this.dataset.modalLoadUrl) {
      $(`#${modalPrefix}-content`).load(this.dataset.modalLoadUrl)
    }
    MicroModal.show('login-modal')
  })
}

export const createModal = (id, title = '', content = '') => {
  let modal = `
  <div class="modal micromodal-slide" id="${id}" aria-hidden="true">
    <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="${id}-title">
            <header class="modal__header">
                <h2 class="modal__title" id="${id}-title">${title}</h2>
                <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
            </header>
            <main class="modal__content" id="${id}-content">${content}</main>
        </div>
    </div>
</div>
  `
  return modal
}



//////////////////
// WEBPACK FOOTER
// ./src/js/sb/modals.js
// module id = 9
// module chunks = 0